import { Dialog, Transition } from "@headlessui/react";
import { Fragment, useState } from "react";
import { DateRange, Range, RangeKeyDict } from "react-date-range"
import { Tab } from "@headlessui/react";
import InlinePicker from "./DateSelector";
import { Button } from "rsuite";
import moment from "moment";
import { t } from "i18next";

interface SelectedData {
    startDate: string,
    endDate: string
}
interface ChildProps {
  onChange: (value: SelectedData) => void;
}

const DateRangePicker = ({onChange} : ChildProps) => {
    const [isOpen, setIsOpen] = useState<boolean>(false)
    const [dateRange, setDateRange] = useState<Range[]>([{ startDate: moment().startOf('month').toDate(), endDate: moment().endOf('month').toDate(), key: 'selection' }])
    const [isSelectRange, setIsSelectRange] = useState('null')
    const [dateVal, setDateVal] = useState(`${moment().startOf('month').format('DD-MM-YYYY')} ~ ${moment().endOf('month').format('DD-MM-YYYY')}`)
    const [selectedDate, setSelectedDate] = useState<SelectedData>({ startDate: moment().startOf('month').format('DD-MM-YYYY'), endDate: moment().endOf('month').format('DD-MM-YYYY') } as SelectedData)

    var january = t("OTHER.month.january");
    var february = t("OTHER.month.february");
    var march = t("OTHER.month.march");
    var april = t("OTHER.month.april");
    var may = t("OTHER.month.may");
    var june = t("OTHER.month.june");
    var july = t("OTHER.month.july");
    var august = t("OTHER.month.august");
    var september = t("OTHER.month.september");
    var october = t("OTHER.month.october");
    var november = t("OTHER.month.november");
    var december = t("OTHER.month.december");

    const [datePlaceHolder, setDatePlaceHolder] = useState('')

    const RANGES = [
        'Tanggal',
        'Pilih Bulan',
        'Pilih Minggu',
    ]
    const month = [
        january,
        february,
        march,
        april,
        may,
        june,
        july,
        august,
        september,
        october,
        november,
        december
    ]
    const thisYear = new Date().getFullYear()
    const value = { month: month[new Date().getMonth()], year: thisYear.toString() }

    const years = Array.from({length: 3}, (_, i) => {return (thisYear - i).toString()})
    const options = { 
        month: month,
        year: years
     }
    const weeks = ['', t('RECITATION.thisWeek'), t('RECITATION.lastWeek'), t('RECITATION.last2Week')]
    const weekValue = {weeks: ''}
    const weekOptions = {
        weeks
    }

    const closeModal = () => {
        if(isSelectRange !== 'null'){
           return setIsSelectRange('null')
        }
        setIsOpen(false)
    }

    const getThisWeek = (type: string, range: string) => {
        moment.updateLocale('id', {week: {dow: 1}})
        let startDate = ''
        let endDate = ''
        if(range === t('RECITATION.lastWeek')){
            startDate = moment().subtract(1, 'weeks').startOf('week').format('DD-MM-YYYY')
            endDate = moment().subtract(1, 'weeks').endOf('week').format('DD-MM-YYYY')
        }
        if(range === t('RECITATION.thisWeek')){
            startDate = moment().startOf('week').format('DD-MM-YYYY')
            endDate = moment().endOf('week').format('DD-MM-YYYY')
        }
        if(range === t('RECITATION.last2Week')){
            startDate = moment().subtract(2, 'weeks').startOf('week').format('DD-MM-YYYY')
            endDate = moment().subtract(2, 'weeks').endOf('week').format('DD-MM-YYYY')
        }
        return type === 'start' ? startDate : endDate
    }
    const getThisMonth = (type: string, range: {month: string, year: number}) => {        
        const startDate = moment().month(range.month).year(range.year).startOf('month').format('DD-MM-YYYY')
        const endDate = moment().month(range.month).year(range.year).endOf('month').format('DD-MM-YYYY')
        return type === 'start' ? startDate : endDate
    }
    const handleChangeValue = (data:any) => {
        let filterDate:SelectedData = {} as SelectedData
        
        if(Object.keys(data)[0] === 'weeks'){
                filterDate = {
                    startDate: getThisWeek('start', data.weeks),
                    endDate: getThisWeek('end',data.weeks),
                }
        } else if (Object.keys(data)[0] === 'month'){
            filterDate = {
                startDate: getThisMonth('start', data),
                endDate: getThisMonth('end', data),
            }
            
        }
        setDateVal(`${filterDate.startDate} ~ ${filterDate.endDate}`)
        setSelectedDate(filterDate)
        
    }
     function openModal() {
        setIsOpen(true);
        setIsSelectRange('null')
        console.log('open', isOpen);
        
    } 
    function classNames(...classes: string[]) {
        return classes.filter(Boolean).join(" ");
    }

    const emitSelected = (data: any) => {
        onChange(data)
    }
    const handleSelect = (ranges: RangeKeyDict) => {
        setDateRange([ranges.selection])
        let selected:SelectedData = {} as SelectedData

        Object.keys(ranges.selection).map((key) => {
            if(key === 'startDate' || key === 'endDate') {
                selected[key] = moment(ranges.selection[key]).format('DD-MM-YYYY')
            }
        })
        
        // emitSelected(selected);
        setSelectedDate(selected)
        setDateVal(`${selected.startDate} ~ ${selected.endDate}`)
    };
    const handleSelected = () => {
        setDatePlaceHolder(dateVal)
        onChange(selectedDate)
        // onSelect()
        closeModal()
    }
    return <>
        <Transition appear show={isOpen} as={Fragment}>
            <Dialog as="div" className="relative z-10" onClose={() => closeModal()}>
                <Transition.Child
                as={Fragment}
                enter="ease-out duration-300"
                enterFrom="opacity-0"
                enterTo="opacity-100"
                leave="ease-in duration-200"
                leaveFrom="opacity-100"
                leaveTo="opacity-0"
                >
                <div className="fixed inset-0 bg-black bg-opacity-25" />
                </Transition.Child>

                <div className="fixed inset-0 overflow-y-auto">
                    <div className="flex min-h-full items-center justify-center p-4 text-center">
                        <Transition.Child
                        as={Fragment}
                        enter="ease-out duration-300"
                        enterFrom="opacity-0 scale-95"
                        enterTo="opacity-100 scale-100"
                        leave="ease-in duration-200"
                        leaveFrom="opacity-100 scale-100"
                        leaveTo="opacity-0 scale-95"
                        >
                            <Dialog.Panel className="w-full max-w-md transform overflow-hidden rounded-2xl bg-white p-6 text-left align-middle shadow-xl transition-all font-montserrat">
                               <p className="text-center font-montserrat font-medium">Range Tanggal</p>
                                 <Tab.Group>
                                    <Tab.List className="flex flex-row justify-between">
                                       {RANGES.map((range, index) => (
                                        <Tab className={
                                            ({ selected }) =>
                                                classNames(
                                                    "py-2.5 text-sm",
                                                    " ",
                                                    selected
                                                    ? `font-montserrat rounded-xl text-sm font-bold text-psp-primary`                  
                                                    : "text-gray-400 bg-none font-montserrat font-medium"
                                                )
                                                } key={index}>
                                            {range}
                                        </Tab>
                                       ))}
                                    </Tab.List>
                                    <Tab.Panels>
                                        <Tab.Panel>
                                            <DateRange
                                                editableDateInputs={false}
                                                ranges={dateRange}
                                                rangeColors={['#0054E6']}
                                                moveRangeOnFirstSelection={false}
                                                onChange={handleSelect}
                                                className="w-full"
                                            />
                                        </Tab.Panel>
                                        {/* <Tab.Panel>
                                            <InlinePicker value={value} option={options} onValueChange={handleChangeValue} />
                                        </Tab.Panel>
                                        <Tab.Panel>
                                              <InlinePicker value={weekValue} option={weekOptions} onValueChange={handleChangeValue} />
                                        </Tab.Panel> */}
                                    </Tab.Panels>
                                </Tab.Group> 
                                <div className="flex gap-2">
                                    <Button className="btn w-full btn-sm btn-primary mt-6" onClick={handleSelected}>Terapkan</Button>
                                </div>
                            </Dialog.Panel>
                        </Transition.Child>
                    </div>
                </div>
            </Dialog>
        </Transition>
        <div className="flex items-center border border-gray-300 rounded-lg px-3 py-2  bg-white text-sm">
            <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" strokeWidth={1.5} stroke="currentColor" className="size-6">
                <path strokeLinecap="round" strokeLinejoin="round" d="M6.75 3v2.25M17.25 3v2.25M3 18.75V7.5a2.25 2.25 0 0 1 2.25-2.25h13.5A2.25 2.25 0 0 1 21 7.5v11.25m-18 0A2.25 2.25 0 0 0 5.25 21h13.5A2.25 2.25 0 0 0 21 18.75m-18 0v-7.5A2.25 2.25 0 0 1 5.25 9h13.5A2.25 2.25 0 0 1 21 11.25v7.5" />
            </svg>

            <input
                type="text"
                placeholder="Select date"
                readOnly
                className="ml-2 w-full outline-none p-1 bg-transparent text-gray-700 placeholder-gray-400"
                onClick={openModal}
                value={datePlaceHolder}
            />
        </div>
    </>
}

export default DateRangePicker